/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.CreateSubAccountResponse | undefined,
  CreateSubAccount: (params: vp.CreateSubAccountRequest) => void,
  reset: () => void,
  CreateSubAccountAsync: (params: vp.CreateSubAccountRequest) => Promise<vp.CreateSubAccountResponse>,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostCreateSubAccount: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldCreateSubAccount, setShouldCreateSubAccount] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.CreateSubAccountRequest>({
    LegalBusinessName: '',
    EmailAddress: '',
    SendWelcomeEmail: false,
    OriginatorName: '',
    OriginatorShortName: '',
  });
  const [response, setResponse] = useState<vp.CreateSubAccountResponse>({
    Success: false,
    ErrorMessage: '',
    Message: '',
    APISharedSecret: '',
    APIKey: '',
  });

  useEffect(() => {
    if (!shouldCreateSubAccount) return () => {};

    const PostCreateSubAccount = async () => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');
      const res = await api.postCreateSubAccount(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldCreateSubAccount) void PostCreateSubAccount();
    setShouldCreateSubAccount(false);
    return () => {
      source.cancel();
    };
  }, [shouldCreateSubAccount]);

  return [
    response,
    (_params: vp.CreateSubAccountRequest) => {
      setParams(_params);
      setShouldCreateSubAccount(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        Message: '',
        APISharedSecret: '',
        APIKey: '',
      });
      setShouldCreateSubAccount(false);
    },
    async (_params: vp.CreateSubAccountRequest) => {
      const res = await api.postCreateSubAccount(_params, source);
      return res;
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostCreateSubAccount);
